/* eslint-disable import/first */
import React from "react";

import { Map, Sliders, Users } from "react-feather";

// Auth components
import SignIn from "../pages/auth/SignIn";
import SignUp from "../pages/auth/SignUp";
import SocialCompleteRegistration from "../pages/auth/SocialCompleteRegistration";
import ResetPassword from "../pages/auth/ResetPassword";
import Page404 from "../pages/auth/Page404";
import Page500 from "../pages/auth/Page500";

// Components components
const Default = React.lazy(() =>
  import("../pages/dashboards/Default/DashboardInsights")
);
const Campaigns = React.lazy(() => import("../pages/pages/Campaigns"));
const FavoriteZones = React.lazy(() => import("../pages/pages/FavoriteZones"));
const AdLibrary = React.lazy(() => import("../pages/pages/AdLibrary"));
const AbTests = React.lazy(() => import("../pages/pages/AbTests"));
const SocialPerformance = React.lazy(() =>
  import("../pages/pages/SocialPerformance")
);
const Settings = React.lazy(() => import("../pages/pages/Settings"));
const Payments = React.lazy(() => import("../pages/pages/Payments"));
const CreateAdCampaign = React.lazy(() =>
  import("../pages/pages/CreateAdCampaign")
);
const PaymentsOptions = React.lazy(() =>
  import("../pages/pages/PaymentsOptions")
);
const MapBox_test = React.lazy(() => import("../pages/maps/MapBox"));
const CampaignCrud = React.lazy(() => import("../pages/pages/CampaignCrud"));
const AdvertisingVault = React.lazy(() =>
  import("../pages/pages/AdvertisingVault")
);
const InvoiceDetails = React.lazy(() =>
  import("../pages/pages/InvoiceDetails")
);
import EmailConfirmation from "../components/EmailConfirmation";
import ChangePassword from "../components/ChangePassword";

const DocumentCenter = React.lazy(() =>
  import("../pages/pages/DocumentCenter")
);

import Ads from "../markdown/Ads";
import IABStandard from "../markdown/IABStandard";
import Politics from "../markdown/Politics";
import Terms from "../markdown/Terms";
import TermsDescription from "../markdown/TermsDescription";

const SurveyDashboard = React.lazy(() =>
  import("../components/survey/SurveyDashboard")
);

const dashboardsRoutes = {
  id: "Dashboard",
  path: "/dashboard",
  icon: <span className="material-icons-round">dashboard</span>,
  component: Default,
};

const createAdCampaignRoutes = {
  id: "Create Ad",
  path: "/createAdCampaign",
  icon: <Sliders />,
  component: CreateAdCampaign,
};

const campaignCrudRoutes = {
  id: "Campaign Crud",
  path: "/campaignCrud",
  icon: <Sliders />,
  component: CampaignCrud,
};

const advertisingVaultRoutes = {
  id: "Advertising Vault",
  path: "/advertising-vault",
  icon: <Sliders />,
  component: AdvertisingVault,
};

const invoiceDetailsRoute = {
  id: "Invoice detail",
  path: "/invoiceDetail",
  icon: <Sliders />,
  component: InvoiceDetails,
};

const paymentOptionRoutes = {
  id: "Payment Options",
  path: "/paymentOptions",
  icon: <span className="material-icons-round">payments</span>,
  component: PaymentsOptions,
};

const campaignRoutes = {
  id: "Campañas",
  path: "/campaigns",
  icon: <span className="material-icons-round">campaign</span>,
  component: null,
  children: [
    {
      path: "/campaigns",
      name: "Publicidades",
      component: Campaigns,
    },
    {
      path: "/campaigns/favorites",
      name: "Zonas Favoritas",
      component: FavoriteZones,
    },
    {
      path: "/campaigns/ad-library",
      name: "Ad Library",
      component: AdLibrary,
    },
    {
      path: "/campaigns/ab-tests",
      name: "Pruebas A/B",
      component: AbTests,
    },
    {
      path: "/campaigns/social-performance",
      name: "Rendimiento social",
      component: SocialPerformance,
    },
  ],
};

const invoiceRoutes = {
  id: "Pagos",
  path: "/payments",
  icon: <span className="material-icons-round">payments</span>,
  component: Payments,
  children: null,
};

const configurationRoutes = {
  id: "Configuraciones",
  path: "/settings",
  icon: <span className="material-icons-round">settings</span>,
  component: Settings,
  children: null,
};

const mapsRoutes = {
  id: "Localizaciones",
  path: "/maps",
  icon: <span className="material-icons-round">location_on</span>,
  component: MapBox_test,
  children: null,
};

const documentRoutes = {
  id: "DocumentCenter",
  path: "/document/center",
  icon: <Map />,
  component: DocumentCenter,
  children: null,
};

const adsRoutes = {
  id: "AdsMD",
  path: "/md/Ads",
  icon: <Map />,
  component: Ads,
  children: null,
};

const iabStandardRoutes = {
  id: "IABStandardMD",
  path: "/md/IABStandard",
  icon: <Map />,
  component: IABStandard,
  children: null,
};

const politicsRoutes = {
  id: "PoliticsMD",
  path: "/md/Politics",
  icon: <Map />,
  component: Politics,
  children: null,
};

const termsRoutes = {
  id: "TermsMD",
  path: "/md/Terms",
  icon: <Map />,
  component: Terms,
  children: null,
};

const termsDescriptionRoutes = {
  id: "TermsDescriptionMD",
  path: "/md/TermsDescription",
  icon: <Map />,
  component: TermsDescription,
  children: null,
};

const surveyRoutes = {
  id: "Encuesta",
  name: "Encuesta",
  path: "/survey-results",
  icon: <span className="material-icons-round">poll</span>,
  component: SurveyDashboard,
  children: [
    {
      path: "/survey-results",
      name: "Resultados",
      component: SurveyDashboard,
    },
  ],
};

// Routes using the Dashboard layout
export const dashboardLayoutRoutes = [
  dashboardsRoutes,
  createAdCampaignRoutes,
  invoiceDetailsRoute,
  campaignCrudRoutes,
  advertisingVaultRoutes,
  paymentOptionRoutes,
  campaignRoutes,
  invoiceRoutes,
  mapsRoutes,
  configurationRoutes,
  documentRoutes,
  adsRoutes,
  iabStandardRoutes,
  politicsRoutes,
  termsRoutes,
  termsDescriptionRoutes,
  surveyRoutes,
];

const authRoutes = {
  id: "Auth",
  path: "/auth",
  icon: <Users />,
  children: [
    {
      path: "/auth/sign-in",
      name: "Sign In",
      component: SignIn,
    },
    {
      path: "/auth/sign-up",
      name: "Sign Up",
      component: SignUp,
    },
    {
      path: "/auth/social/complete-registration",
      name: "Complete Social Registration",
      component: SocialCompleteRegistration,
    },
    {
      path: "/auth/reset-password",
      name: "Reset Password",
      component: ResetPassword,
    },
    {
      path: "/auth/404",
      name: "404 Page",
      component: Page404,
    },
    {
      path: "/auth/500",
      name: "500 Page",
      component: Page500,
    },
    {
      path: "/emailConfirmation/:id",
      name: "Email confirmation",
      component: EmailConfirmation,
    },
    {
      path: "/forgotPasswordLast/:id",
      name: "Change Password",
      component: ChangePassword,
    },
  ],
  component: null,
};

// Routes using the Auth layout
export const authLayoutRoutes = [authRoutes];

// Routes visible in the sidebar
export const sidebarRoutes = [
  dashboardsRoutes,
  campaignRoutes,
  invoiceRoutes,
  mapsRoutes,
  surveyRoutes,
  configurationRoutes,
];
